import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";

export interface ConfusionCounts {
	fn: number;
	fp: number;
	tn: number;
	tp: number;
}

export interface ReplayReport {
	confusion: {
		proposed: ConfusionCounts;
		recorded: ConfusionCounts;
		verdicted: number;
	};
	decisions: {
		proposed: Record<string, number>;
		recorded: Record<string, number>;
	};
	flips: {
		classId: string;
		from: string;
		posteriorFrom: number;
		posteriorTo: number;
		to: string;
		verificationId: string;
	}[];
	replayed: number;
	scanned: number;
	skipped: number;
	truncated: boolean;
}

export interface ReplayRequestBody {
	classId?: string;
	limit?: number;
	overrides?: Record<string, unknown>;
}

/** Re-score the selected organization's verifications under a proposed config. */
export const useReplay = () =>
	useMutation({
		mutationFn: async (body: ReplayRequestBody) => {
			const response = await apiClient.post<ReplayReport>(
				ENDPOINTS.shadow.plausibility.replay,
				body,
			);
			return response.data;
		},
	});
